var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',[_c('div',{staticClass:"relative pb-8"},[(_vm.separator)?_c('span',{staticClass:"absolute top-4 left-4 -ml-px h-full w-0.5 bg-gray-200"}):_vm._e(),_c('div',{staticClass:"relative flex space-x-3"},[_c('div',[_vm._t("icon")],2),_c('div',{staticClass:"min-w-0 flex-1 pt-1.5 flex justify-between space-x-4"},[_vm._t("default")],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }